// Import external
import { Component } from '@angular/core';

@Component({

    selector: 'syn-error-cat',
    templateUrl: 'error-cat.component.html',
    styleUrls: ['error-cat.component.scss']
})
export class ErrorCatComponent {
}
